module.exports = __webpack_public_path__ + "static/fabric-color-min-d39630e0a87b0793106c03c3f4ac7e77.webp";